import React from "react";
import BottomFloat from "../components/containers/BottomFloat";

import Button from "../components/Button/Button";

import { useHistory } from "react-router-dom";

import { useDispatch, useSelector } from "react-redux";

import { emptyThankYou } from "../redux/items/ThankYou";
import CardBookingSpecific from "../components/CardBookingSpecific";

const Final = () => {
  const hist = useHistory();
  const dispatch = useDispatch();
  const bet = useSelector((state) => state.thankYouBet);

  React.useEffect(() => {
    if (bet?.bet === undefined) hist.push("/");
    // eslint-disable-next-line
  }, []);

  return (
    <CardBookingSpecific bet={bet}>
      <BottomFloat>
        <Button
          align="center"
          onClick={() => {
            dispatch(emptyThankYou());
            hist.push("/");
          }}
          style={{ marginLeft: 16 }}
        >
          Go Back to Home
        </Button>
      </BottomFloat>
    </CardBookingSpecific>
  );
};

export default Final;
